import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
const ActionButton = styled((props) => _jsx(LoadingButton, Object.assign({}, props, { size: 'small' })))(({ theme }) => {
    var _a, _b, _c, _d;
    return ({
        background: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation.background,
        color: (_b = theme.account) === null || _b === void 0 ? void 0 : _b.navigation.text,
        borderRadius: 0,
        width: '150px',
        justifyContent: 'space-between',
        textTransform: 'none',
        '&:hover': {
            color: (_c = theme.account) === null || _c === void 0 ? void 0 : _c.navigation.background,
            background: (_d = theme.account) === null || _d === void 0 ? void 0 : _d.navigation.text,
        },
    });
});
export default ActionButton;
